<template>
  <responsive-drawer-layout>
    <template v-slot:content>
      <!--      <div class="inherit-height">-->
      <!-- calender view -->
      <duties-calendar v-if="dutiesDisplayMode === 'calendar'"></duties-calendar>
      <!-- Grid view -->
      <v-container v-else-if="dutiesDisplayMode === 'boxes'" class="inherit-height scroll-container">
       <duties-grid-view :dutiesByMonth="dutiesByMonth" @onDutySelected="onDutySelected"></duties-grid-view>
      </v-container>

      <!-- list view -->
      <v-container v-else class="inherit-height scroll-container">
       <duties-list-view :dutiesByMonth="dutiesByMonth"></duties-list-view>
      </v-container>
    </template>
  </responsive-drawer-layout>
</template>

<script>
import index from '../index.js';
import { push } from '@/common/utils';
import dateUtils from '@/common/dateUtils';
import dutyService from '../common/dutyService';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import { mapState } from 'vuex';
import MODULE_ID from '../moduleId';
import ResponsiveDrawerLayout from '@/layouts/ResponsiveDrawerLayout';
import dutiesUtil from '@/modules/myDuties/common/dutiesUtil';
import DutiesCalendar from '@/modules/myDuties/views/DutiesCalendar.vue';
import DutiesGridView from "@/modules/myDuties/views/DutiesGridView.vue";
import DutiesListView from "@/modules/myDuties/views/DutiesListView.vue";
const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;
export default {
  name: 'DutyList',
  mixins: [common, configMixin, dateTimeMixin],
  components: {
    DutiesListView,
    DutiesGridView,
    DutiesCalendar,
    ResponsiveDrawerLayout,
  },
  props: {
    moduleConfig: Object,
  },
  data() {
    return {
      moduleType: index.moduleType,
      today: Date.now(),

      selectedEvent: {},
      ready: false,
    };
  },
  computed: {
    ...mapState(MODULE_ID, ['duties', 'dutiesDisplayMode']),

    dutiesByMonth() {
      let dutiesByMonth = this.duties.slice().sort((d1, d2) => {
        let date1 = dateUtils.parseISOString(d1.day);
        let date2 = dateUtils.parseISOString(d2.day);
        d1.date = date1;
        d2.date = date2;

        d1.year = date1.getFullYear();
        d2.year = date2.getFullYear();

        d1.month = date1.getMonth();
        d2.month = date2.getMonth();

        let yearDiff = d1.year - d2.year;
        if (yearDiff !== 0) {
          return yearDiff;
        }
        return d1.month - d2.month;
      });
      let dutiesByYear_Month = {};
      dutiesByMonth.forEach((d) => {
        push(dutiesByYear_Month, `${d.year}_${d.month}`, d);
      });
      return Object.keys(dutiesByYear_Month)
        .sort(dutyService.yearMonthSortComparator)
        .map((k) => {
          return { yearMonth: k, listOfDuties: dutiesByYear_Month[k].sort((i1, i2) => i1.month - i2.month) };
        });
    },
    dutiesCalendarByDayNum() {
      let sortedDuties = this.duties.slice().sort((d1, d2) => {
        let date1 = dateUtils.parseISOString(d1.day);
        let date2 = dateUtils.parseISOString(d2.day);
        return date1.getTime() - date2.getTime();
      });
      if (sortedDuties.length === 0) {
        sortedDuties.push(new Date().toISOString());
      }
      let firstDate = dateUtils.parseISOString(sortedDuties[0].day);
      let offset;
      let day = firstDate.getDay();
      if (day >= 1) {
        offset = day - 1;
      } else {
        offset = 7;
      }

      let firstMonday = new Date(firstDate.getTime() - offset * ONE_DAY_IN_MS);

      let dutiesByDay = {};
      this.duties.forEach((d) => {
        let date = dateUtils.parseISOString(d.day);
        dutiesByDay[`${date.getFullYear()}_${date.getMonth()}_${date.getDate()}`] = d;
      });

      let daysCount = (dateUtils.parseISOString(sortedDuties[sortedDuties.length - 1].day).getTime() - firstDate.getTime()) / ONE_DAY_IN_MS + offset;
      let dutiesCalendarByTime = [];

      let timeFirstMonday = firstMonday.getTime();
      for (let d = 0; d < daysCount; d++) {
        let date = new Date(timeFirstMonday + d * ONE_DAY_IN_MS);
        let dateStr = `${date.getFullYear()}_${date.getMonth()}_${date.getDate()}`;
        dutiesCalendarByTime.push({ date, d, weekday: date.getDay(), dateStr, duty: dutiesByDay[dateStr] });
      }

      return dutiesCalendarByTime;
    },

    locale() {
      return this.$store.state.language.locale;
    },
  },
  methods: {
    getDateFromDutiesCalendarItem(dayNumber) {
      let dateDuty = this.dutiesCalendarByDayNum[dayNumber];
      return dateUtils.formatAsLocaleWeekDayDate(dateDuty.date);
    },
    /**
     * Year and month in String form ${year}_${month_zero_based}
     * @param yearMonth
     * @returns {string}
     */
    getMonthTitle(yearMonth) {
      return dutiesUtil.getMonthTitle(yearMonth, this.locale);
    },

    time(minutesAfterMidnight) {
      return this.getTimeFromMinutesAfterMidnight(this.configuredTimeFormat, minutesAfterMidnight);
      //return this.getTimeFromMinutesAfterMidnight(this.moduleConfig.timeFormat, minutesAfterMidnight);
    },
    setToday() {
      this.value = '';
    },

    onDutySelected(duty) {
      this.$router.push(`/myduties/detail/${this.duty.id}`);
    },
  },
};
</script>
